<template>
  <!-- Main navbar -->
  <v-card class="d-flex w-100 elevation-0 transparent" flat>
    <!--<div class="navbar-header">
      <ul class="nav navbar-nav pull-right visible-xs-block">
        <li>
          <a data-toggle="collapse" data-target="#navbar-mobile">
            <i class="icon-tree5"></i>
          </a>
        </li>
        <li>
          <a class="sidebar-mobile-main-toggle">
            <i class="icon-paragraph-justify3"></i>
          </a>
        </li>
      </ul>
    </div>-->
    <v-toolbar-title >
        <span v-html="tituloIcono" class="mr-2"></span>
        {{titulo}}
        <!-- <i class="icon-home2 position-left"></i> -->
              <!-- {{ $t("lang.home.dashboard") }} -->
    </v-toolbar-title>
    <v-card-actions class="ml-auto py-0 pr-0">
      <div class=" text-left ml-auto" v-if="$store.getters.isLoggedIn && !staffControl && !isSys4() && $vuetify.breakpoint.name !== 'xs'">
        <div class="pr-2 d-flex align-center">
          <img class="mr-2" src="@/assets/css/icons/flaticon/user.svg" width="18" height="20" />
          <v-text-field
            label="Buscar cliente..."
            class="mb-0"
            single-line
            ref="busqueda" v-model="busquedaCliente"
            type="text" id="busq"
          ></v-text-field>
          <!--<input   placeholder="Buscar cliente..." >-->
          <v-btn flat icon small class="mx-0" v-if="busquedaCliente != ''" @click="reset"><v-icon class="primary-color">close</v-icon></v-btn>
          <v-btn flat icon v-if="cliente === null"  @click="filtrarBusqueda(0)"><v-icon class="primary-color ">search</v-icon></v-btn>
        </div>
        <div class="datoscliente pb-3" v-if="clientePreSelec !== null" @click="selecCliente()">
          <div class="text-left cabecera pt-3">
              <img class="ml-1 mb-2 mr-1" src="@/assets/css/icons/flaticon/user.svg" width="18" height="20" />
              <span>{{ clientePreSelec.nombre }}</span>
          </div>     
          <div class="d-flex justify-content-between pl-2 pt-2">
              <div class="d-flex flex-column">
                  <span align="left" style="color:#2762af">Teléfono</span>
                  <span align="left">{{ clientePreSelec.movil === '' ? clientePreSelec.telefonoUno ==='' ? clientePreSelec.telefonoDos : clientePreSelec.telefonoUno : clientePreSelec.movil }}</span>
                  <span align="left" style="color:#2762af">Email</span>
                  <span align="left">{{ clientePreSelec.email }}</span>
              </div>   
          </div>            
        </div>    
      </div>
      <div v-if="$store.getters.isLoggedIn && !staffControl">
          <vue-select dir="rtl" class="select-tienda primary-color" :options="listaTiendaIds" :searchable="false" :clearable="false" :reduce="listaTiendaIds => listaTiendaIds.id" 
            @input="cambioTienda" :label="isSys4() ? 'clicode' : 'nombre'" v-model="idTienda">
            <!-- <template #option="{ id, nombre }"  v-if="isSys4()">
              {{ nombre }}-{{ id }}
            </template>
            <template #selected-option="{ id, nombre }" v-if="isSys4()">
              {{ nombre }}-{{ id }}
            </template> -->
          </vue-select>
          <!-- <i class="icon-chevron-left" v-if="hayTiendaAnterior()" @click="tiendaAnterior()"></i>
            <h3>{{bip_item_id}} - Nombre OP</h3>
          <i class="icon-chevron-right" v-if="hayTiendaSiguiente()" @click="tiendaSiguiente()"></i> -->
      </div>
    </v-card-actions>
  </v-card>
  <!-- /main navbar -->
</template>

<script>
import { ClienteApiService } from '@/api/ClienteApiService';

const clienteApi = new ClienteApiService()
export default {
  data() {
    return {
      idTienda: this.$store.getters.getIdTienda,
      busquedaCliente: '',
      clientePreSelec: null
      // listaTiendaIds: this.$store.getters.getTiendaIds
    }
  },
  computed: {
    cambiotienda () {
      return this.$store.getters.getIdTienda
    },
    listaTiendaIds () {
      return this.$store.getters.getTiendaIds
    },
    titulo () {
      return this.$store.getters.getTitulo
    },
    tituloIcono () {
      return this.$store.getters.getTituloIcono
    },
    staffControl () {
      return this.$store.getters.isStaffControl
    },
    cliente () {
      return this.$store.getters.getCliente
    }
  },
  created() {
    if (this.cliente !== null) {
      this.busquedaCliente = this.cliente.nombre
    }
  },
  methods: {
    cambioTienda(value){
      this.$store.dispatch("cambioTienda", value)
        .then(() => {
          // this.$cookies.set("idtienda", value)
        })
        .catch(error => {
          console.log(error)
        })
    },
    reset(){
      this.busquedaCliente = "";
      if (this.cliente !== null) {
        this.$store.dispatch("setBusquedaCliente", "")
        this.$store.dispatch("setCliente", null)
        this.clientePreSelec = null;
        this.$router.push({ name: 'listaclientes'})
      }
        
    },
    filtrarBusqueda(dato){
      let valor = this.busquedaCliente;
      if(valor != ""){
          clienteApi.getClientesFilter(valor,dato)
          .then(data => {
            if (data.content.length === 0)
              this.clientePreSelec = null;
            else if (data.content.length === 1)    
            {
              //si solo hay un cliente lo sacamos si hay mas vamos al aprtado de lista de clientes
              this.clientePreSelec = data.content[0]
            } else {
              this.$store.dispatch("setBusquedaCliente", valor)
              this.$router.push({ name: 'listaclientes'})
            }
          })
      }
    },
    selecCliente() {
      this.$store.dispatch("setCliente", this.clientePreSelec)
      this.clientePreSelec = null
    }
  },
  watch: {
    cambiotienda (value) {
      this.idTienda = value;
      this.cambioTienda(value)
    },
    cliente(value) {
      if (value !== null) {
        this.busquedaCliente = value.nombre
      }
    }
  }
}
</script>